// src/lib/managers/conversation/contractText.ts

/**
 * Les textes courts du contrat par étapes (faits, questions à choix), lus et bornés comme l'Api-Ai
 * les lit : espaces regroupés, longueur comptée en caractères. Un emoji compte pour un, comme en
 * Python, et non pour deux comme `String.length` : un texte que l'Api-Ai accepte n'est pas refusé ici.
 */

const words = (text: string): string =>
    text.split(/\s+/).filter(Boolean).join(" ");

/** Le nombre de caractères d'un texte (et non d'unités UTF-16). */
export const charCount = (text: string): number => [...text].length;

/** Un texte sur une ligne, entre 1 et `max` caractères ; sinon `undefined`. */
export const oneLine = (value: unknown, max: number): string | undefined => {
    if (typeof value !== "string") return undefined;
    const text = words(value);
    return text.length > 0 && charCount(text) <= max ? text : undefined;
};

/** Un texte sur une ligne, coupé à `max` caractères (« … » compris) s'il est plus long. */
export const clip = (text: string, max: number): string => {
    const line = words(text);
    const chars = [...line];
    return chars.length <= max
        ? line
        : `${chars
              .slice(0, max - 1)
              .join("")
              .trimEnd()}…`;
};
